function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import queryString from 'qs';
import { toUrlQuery as sortToUrlQuery } from './sort-options';
import { toUrlQuery as localitiesToUrlQuery } from './localities';
import * as defaults from './defaults';
export default (_ref => {
  var searchResultsUrl = _ref.searchResultsUrl,
    localities = _ref.localities,
    sort = _ref.sort,
    tab = _ref.tab;
  var arrayFormat = {
    arrayFormat: 'comma'
  };
  var path;
  if (localities) {
    path = localities.length === 1 ? "".concat(searchResultsUrl.replace(/\/$/, ''), "/").concat(localities[0].slug, "/") : searchResultsUrl;
  } else {
    path = window.location.pathname;
  }
  var queryParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, queryString.parse(window.location.search.replace('?', '')) || {}), localities != null && localitiesToUrlQuery(localities.length === 1 ? [] : localities)), tab && {
    tab: tab === defaults.tab ? undefined : tab
  }), sort && sortToUrlQuery({
    sort
  }));
  var query = queryString.stringify(queryParams, arrayFormat);
  window.history.pushState({}, null, "".concat(path).concat(query ? "?".concat(query) : ''));
});